<template>
	<div>
		<a-modal :title="$t('studentsCom.teacherEvaluation')" :width="650" :visible="visible" @cancel="handleCancel" :closable="false" :footer="null"
			:pagination="false">
			<div class=" d-flex flex-column align-items-center ">
				<img :src="data.photo_image" alt="" class="photo-40" />
				<div class="mt-3 ftr-1-25">
					{{data.name}}
				</div>
				<div class="cl-info mt-3">
					{{$t('studentsCom.classSatisfaction')}}
				</div>
				<a-rate v-model:value="rate" />
				<div class="cl-info mt-2">
					教得超好的
				</div>
				<a-divider />
				<div class="wid-100">
					<div class="cl-info">
						{{$t('studentsCom.selectTeachingTraits',{name:data.name+data.surname})}}
					</div>
					<div class="d-flex flex-wrap">
						<div class=" wid-fit m-2 py-1 px-2 clickAct"
							:class="tagsList.includes(item)?' bg-theme cl-w':'bg-F3F3F3'"
						 @click="selectTag(item)" v-for="item in tags">
							{{item}}
						</div>
					</div>
				</div>
				<a-divider />
				<div class="wid-100">
					<div class="cl-info">
						{{$t('studentsCom.classFeedback',{name:data.name+data.surname})}}
					</div>
					<div class="form-check">
					  <input class="form-check-input" type="radio" :checked="status==1" name="flexRadioDefault" id="flexRadioDefault1"
					  @click="status=1">
					  <label class="form-check-label" for="flexRadioDefault1">
					   {{$t('studentsCom.showOnProfileNamed')}}
					  </label>
					</div>
					<div class="form-check">
					  <input class="form-check-input" type="radio" :checked="status==2" name="flexRadioDefault" id="flexRadioDefault2"
					   @click="status=2">
					  <label class="form-check-label" for="flexRadioDefault2">
					    {{$t('studentsCom.showOnProfileAnonymous')}}
					  </label>
					</div>
					<textarea class="mt-3 border-gray wid-100 p-2 br12" v-model="content"
					style="height: 150px;" :placeholder="$t('studentsCom.writeClassExperience')"></textarea>
				</div>
				<div class="mt-4 d-flex justify-content-center" v-if="JSON.stringify(data.teacher_comment)=='[]'">
					<button type="button" class="btn btn-outline-gray px-4" @click="handleCancel()"> {{$t('common.cancel')}} </button>
					<button type="button" class="btn btn-theme ml16 px-4" @click="createComment()">{{$t('common.submit')}}</button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			order_id:{
				type: Number,
				default: 0,
			},
			data:{
				type: Object,
				default: {},
			}
		},
		data() {
			return {
				codeLoading: false,
				account: '',
				rate:5,
				tags:['讲课清晰','态度温和','专业','效率高','态度恶劣','讲课模糊'],
				tagsList:[],
				content:'',
				status:1,//状态:1=正常,2=匿名
			}
		},
		created() {
			if(this.data.teacher_comment&&this.data.teacher_comment.id){
				this.rate = Number(this.data.teacher_comment.score) 
				this.content = this.data.teacher_comment.content
				this.tagsList = this.data.teacher_comment.tags.split(",")
			}
		},
		methods: {
			handleCancel() {
				this.$emit('cancel')
			},
			selectTag(item){
				if(this.tagsList.includes(item)){
					this.tagsList.forEach((t,i)=>{
						if(t==item){
							this.tagsList.splice(i,1)
						}
					})
				}else{
					this.tagsList.push(item)
				}
				
			},
			// 预约订单评论
			createComment(){
				this.$http.api('reservation/createComment',{
					order_id:this.order_id,
					score:this.rate,
					tags:this.tagsList,
					content:this.content,
					status:this.status
				}).then(res=>{
					this.$emit('confirm')
				})
			},
		}
	}
</script>

<style>
</style>